<template>
  <b-focus-group-collection>
    <b-roving-focus-group-impl v-bind="$attrs">
      <slot />
    </b-roving-focus-group-impl>
  </b-focus-group-collection>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import BRovingFocusGroupImpl from './roving-focus-group-impl.vue'
import { BCollection as BFocusGroupCollection } from './roving-focus-group'

export default defineComponent({
  name: 'BRovingFocusGroup',
  components: {
    BFocusGroupCollection,
    BRovingFocusGroupImpl,
  },
})
</script>
